import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Button, Modal as AntdModal } from "antd";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

const Modal = ({message, success, onClose, onOk, showCancelButton = true, showOkButton = true, approveText, rejectText }: { message: string, success?: boolean, onClose?: () => void, onOk?: () => void, showCancelButton?: boolean, showOkButton?: boolean, approveText?: string, rejectText?: string }) => {
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (message) {
      setOpen(true);
    }
  }, [message]);
  
  const handleClose = (e: React.MouseEvent<HTMLButtonElement>) => {
      setOpen(false);
      onClose?.();
  };
  
  const handleOk = (e: React.MouseEvent<HTMLButtonElement>) => {
    setOpen(false);
    onOk?.();
  };

  return (
    <AntdModal
    centered
    open={open}
    onCancel={handleClose}
    onOk={handleOk}
    okButtonProps={{ style: { display: 'none' } }}
    cancelButtonProps={{ style: { display: 'none' } }}
    width={500}
  > 
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
    {success ? <CheckCircleOutlined style={{ fontSize: '48px', color: '#52c41a' }} /> : <CloseCircleOutlined style={{ fontSize: '48px', color: '#f5222d' }} />}
    <p style={{ textAlign: 'center', fontSize: '24px', fontWeight: 'bold' }}>{message}</p>
    <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', width: '100%' }}>
      { onClose && showCancelButton && <Button onClick={handleClose} style={{ width: '100px', backgroundColor: '#f5222d', color: '#fff', border: 'none', borderRadius: '30px' }}>{intl.formatMessage({ id: rejectText || "CANCEL" })}</Button> }  
      { onOk && showOkButton && <Button onClick={handleOk} style={{ width: '100px', backgroundColor: '#1890ff', color: '#fff', border: 'none', borderRadius: '30px' }}>{intl.formatMessage({ id: approveText || "Yes" })}</Button> }
    </div>
  </div>
  </AntdModal>
  );
};

export default Modal;